import applyRecord from './ApplyRecord';
import copy from './Copy';
import create from './Create';
import folderBind from './FolderBind';
import hardDelete from './HardDelete';
import mailboxLogin from './MailboxLogin';
import mailItemsAccessed from './MailItemsAccessed';
import messageBind from './MessageBind';
import move from './Move';
import moveToDeletedItems from './MoveToDeletedItems';
import recordDelete from './RecordDelete';
import searchQueryInitiated from './SearchQueryInitiated';
import send from './Send';
import sendAs from './SendAs';
import sendOnBehalf from './SendOnBehalf';
import softDelete from './SoftDelete';
import update from './Update';
import updateCalendarDelegation from './UpdateCalendarDelegation';
import updateComplianceTag from './UpdateComplianceTag';
import updateFolderPermissions from './UpdateFolderPermissions';
import updateInboxRules from './UpdateInboxRules';

const operations: { [key: string]: any } = {
    ApplyRecord: applyRecord,
    Copy: copy,
    Create: create,
    FolderBind: folderBind,
    HardDelete: hardDelete,
    MailboxLogin: mailboxLogin,
    MailItemsAccessed: mailItemsAccessed,
    MessageBind: messageBind,
    Move: move,
    MoveToDeletedItems: moveToDeletedItems,
    RecordDelete: recordDelete,
    SearchQueryInitiated: searchQueryInitiated,
    Send: send,
    SendAs: sendAs,
    SendOnBehalf: sendOnBehalf,
    SoftDelete: softDelete,
    Update: update,
    UpdateCalendarDelegation: updateCalendarDelegation,
    UpdateComplianceTag: updateComplianceTag,
    UpdateFolderPermissions: updateFolderPermissions,
    UpdateInboxRules: updateInboxRules,
};

export default operations;
